import React from 'react';
import {
  Field,
  WrappedFieldInputProps,
  WrappedFieldMetaProps
} from 'redux-form';
import SelectFieldComponent from '../../../../forms/helpers/fields/SelectFieldComponent';
import { MetadataFormFieldRow } from '@cube3/ui/src/metadata/MetadataFormField';
import { Typography } from '@cube3/ui/src/typography/Typography';
import { dateParser } from '@cube3/forms/src/utils/makeParser';
import DatePicker from '@cube3/forms/src/fields/DatePicker';
import { makeCSS } from '@cube3/cubicle/src/utils/makeCSS';
import { isMobile } from 'react-device-detect';

interface Props extends WrappedFieldInputProps, WrappedFieldMetaProps {}

const useCSS = makeCSS(({ theme }) => {
  return {
    mobileStyle: {
      display: 'flex',
      width: 'calc(100vw - 50px)',
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginTop: theme.spacing[3]
    }
  };
});

const options = ['Specific period', 'Never expires'];
const parser = (val) => val === 'Specific period';
const formatter = (val) => (val ? 'Specific period' : 'Never expires');

export const ContractDurationField: React.FunctionComponent<Props> = (
  props
) => {
  const { name, value, error } = props;

  const classes = useCSS();

  return (
    <>
      <Field
        name={`${name}.expires`}
        component={(props) => (
          <SelectFieldComponent
            {...props}
            data-cy="select-new-contract-period"
          />
        )}
        options={options}
        format={formatter}
        parse={parser}
      />

      {value?.expires && (
        <div className={isMobile ? classes.mobileStyle : ''}>
          <Field
            name={`${name}.starts_at`}
            component={DatePickerField}
            props={{
              label: 'Starts at',
              isNested: true,
              'data-cy': 'date-picker-start-date',
              required: true
            }}
            validate={(val) => (!val ? 'required' : undefined)}
            parse={dateParser}
          />
          <Field
            name={`${name}.expires_at`}
            component={DatePickerField}
            props={{
              minDate: value?.expires_at || undefined,
              label: 'Expires at',
              isNested: true,
              'data-cy': 'date-picker-expiring-date',
              required: true
            }}
            validate={(val) => (!val ? 'required' : undefined)}
            parse={dateParser}
          />
        </div>
      )}
      {error && (
        <Typography color="danger1">Please fill out all dates</Typography>
      )}
    </>
  );
};

export const DatePickerField = (propsWithState) => {
  const { input, meta, ...restProps } = propsWithState;
  return (
    <MetadataFormFieldRow {...propsWithState} error={meta.error}>
      <DatePicker
        {...restProps}
        {...meta}
        onChange={input.onChange}
        value={input.value}
      />
    </MetadataFormFieldRow>
  );
};
